// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape
} from './client'
import { client } from './client.gen'
import type {
  ApiAgentsAssigneesCreateData,
  ApiAgentsAssigneesCreateResponses,
  ApiAgentsAssigneesDestroyData,
  ApiAgentsAssigneesDestroyResponses,
  ApiAgentsAssigneesRetrieveData,
  ApiAgentsAssigneesRetrieveResponses,
  ApiAgentsAutoApprovedToolsDestroyData,
  ApiAgentsAutoApprovedToolsDestroyResponses,
  ApiAgentsCollaboratorsCreateData,
  ApiAgentsCollaboratorsCreateResponses,
  ApiAgentsCollaboratorsDestroyData,
  ApiAgentsCollaboratorsDestroyResponses,
  ApiAgentsCollaboratorsRetrieveData,
  ApiAgentsCollaboratorsRetrieveResponses,
  ApiAgentsCreateData,
  ApiAgentsCreateResponses,
  ApiAgentsDestroyData,
  ApiAgentsDestroyResponses,
  ApiAgentsListData,
  ApiAgentsListResponses,
  ApiAgentsMcpServersCreateData,
  ApiAgentsMcpServersCreateResponses,
  ApiAgentsMcpServersDestroyData,
  ApiAgentsMcpServersDestroyResponses,
  ApiAgentsMcpServersListData,
  ApiAgentsMcpServersListResponses,
  ApiAgentsMcpServersPartialUpdateData,
  ApiAgentsMcpServersPartialUpdateResponses,
  ApiAgentsMemoriesCreateData,
  ApiAgentsMemoriesCreateResponses,
  ApiAgentsMemoriesDestroyData,
  ApiAgentsMemoriesDestroyResponses,
  ApiAgentsMemoriesDocumentsConfirmCreateData,
  ApiAgentsMemoriesDocumentsConfirmCreateResponses,
  ApiAgentsMemoriesDocumentsCreateData,
  ApiAgentsMemoriesDocumentsCreateResponses,
  ApiAgentsMemoriesDocumentsDestroyData,
  ApiAgentsMemoriesDocumentsDestroyResponses,
  ApiAgentsMemoriesDocumentsListData,
  ApiAgentsMemoriesDocumentsListResponses,
  ApiAgentsMemoriesDocumentsRetrieveData,
  ApiAgentsMemoriesDocumentsRetrieveResponses,
  ApiAgentsMemoriesDocumentsSearchCreateData,
  ApiAgentsMemoriesDocumentsSearchCreateResponses,
  ApiAgentsMemoriesListData,
  ApiAgentsMemoriesListResponses,
  ApiAgentsMemoriesPartialUpdateData,
  ApiAgentsMemoriesPartialUpdateResponses,
  ApiAgentsMemoriesRetrieveData,
  ApiAgentsMemoriesRetrieveResponses,
  ApiAgentsMemoriesUpdateData,
  ApiAgentsMemoriesUpdateResponses,
  ApiAgentsMemorySourceRetrieveData,
  ApiAgentsMemorySourceRetrieveResponses,
  ApiAgentsMemorySourceUpdateData,
  ApiAgentsMemorySourceUpdateResponses,
  ApiAgentsPartialUpdateData,
  ApiAgentsPartialUpdateResponses,
  ApiAgentsRetrieveData,
  ApiAgentsRetrieveResponses,
  ApiAgentsScaffoldCreateData,
  ApiAgentsScaffoldCreateResponses,
  ApiAgentsSharepointFilesEventsListData,
  ApiAgentsSharepointFilesEventsListResponses,
  ApiAgentsSharepointFilesListData,
  ApiAgentsSharepointFilesListResponses,
  ApiAgentsSharepointScopeRetrieveData,
  ApiAgentsSharepointScopeRetrieveResponses,
  ApiAgentsSharepointScopeValidateCreateData,
  ApiAgentsSharepointScopeValidateCreateResponses,
  ApiAgentsSharepointSyncCreateData,
  ApiAgentsSharepointSyncCreateResponses,
  ApiAgentsSharepointSyncRunsListData,
  ApiAgentsSharepointSyncRunsListResponses,
  ApiAgentsSharepointSyncRunsRetrieveData,
  ApiAgentsSharepointSyncRunsRetrieveResponses,
  ApiAgentsSkillsAttachCreateData,
  ApiAgentsSkillsAttachCreateResponses,
  ApiAgentsSkillsDetachOrToggleDestroyData,
  ApiAgentsSkillsDetachOrToggleDestroyResponses,
  ApiAgentsSkillsDetachOrTogglePartialUpdateData,
  ApiAgentsSkillsDetachOrTogglePartialUpdateResponses,
  ApiAgentsSkillsListData,
  ApiAgentsSkillsListResponses,
  ApiAgentsToolsRetrieveData,
  ApiAgentsToolsRetrieveResponses,
  ApiAgentsToolsUpdateData,
  ApiAgentsToolsUpdateResponses,
  ApiAgentsUpdateData,
  ApiAgentsUpdateResponses,
  ApiApprovalsListData,
  ApiApprovalsListResponses,
  ApiApprovalsPoliciesListData,
  ApiApprovalsPoliciesListResponses,
  ApiApprovalsRetrieveData,
  ApiApprovalsRetrieveResponses,
  ApiApprovalsStatsRetrieveData,
  ApiApprovalsStatsRetrieveResponses,
  ApiCardPauseCreateData,
  ApiCardPauseCreateResponses,
  ApiCardPauseRetrieveData,
  ApiCardPauseRetrieveResponses,
  ApiChannelsCreateData,
  ApiChannelsCreateResponses,
  ApiChannelsCrmSubscriptionDestroyData,
  ApiChannelsCrmSubscriptionDestroyResponses,
  ApiChannelsCrmSubscriptionRetrieveData,
  ApiChannelsCrmSubscriptionRetrieveResponses,
  ApiChannelsCrmSubscriptionUpdateData,
  ApiChannelsCrmSubscriptionUpdateResponses,
  ApiChannelsDestroyData,
  ApiChannelsDestroyResponses,
  ApiChannelsListData,
  ApiChannelsListResponses,
  ApiChannelsPartialUpdateData,
  ApiChannelsPartialUpdateResponses,
  ApiChannelsRetrieveData,
  ApiChannelsRetrieveResponses,
  ApiChannelsRotateSecretCreateData,
  ApiChannelsRotateSecretCreateResponses,
  ApiChannelsUpdateData,
  ApiChannelsUpdateResponses,
  ApiChannelsWebhookCreateData,
  ApiChannelsWebhookCreateResponses,
  ApiChatCreateData,
  ApiChatCreateResponses,
  ApiChatFilesConfirmCreateData,
  ApiChatFilesConfirmCreateResponses,
  ApiChatFilesCreateData,
  ApiChatFilesCreateResponses,
  ApiChatFilesDestroyData,
  ApiChatFilesDestroyResponses,
  ApiChatFilesDownloadRetrieveData,
  ApiChatFilesDownloadRetrieveResponses,
  ApiChatResumeCreateData,
  ApiChatResumeCreateResponses,
  ApiMcpCatalogConnectCreateData,
  ApiMcpCatalogConnectCreateResponses,
  ApiMcpCatalogDisconnectCreateData,
  ApiMcpCatalogDisconnectCreateResponses,
  ApiMcpCatalogListData,
  ApiMcpCatalogListResponses,
  ApiMcpCatalogToolsListData,
  ApiMcpCatalogToolsListResponses,
  ApiMcpOauthCallbackRetrieveData,
  ApiMcpServersCreateData,
  ApiMcpServersCreateResponses,
  ApiMcpServersDestroyData,
  ApiMcpServersDestroyResponses,
  ApiMcpServersListData,
  ApiMcpServersListResponses,
  ApiMcpServersOauthDisconnectCreateData,
  ApiMcpServersOauthDisconnectCreateResponses,
  ApiMcpServersOauthRetrieveData,
  ApiMcpServersOauthRetrieveResponses,
  ApiMcpServersOauthStartCreateData,
  ApiMcpServersOauthStartCreateResponses,
  ApiMcpServersPartialUpdateData,
  ApiMcpServersPartialUpdateResponses,
  ApiMcpServersRetrieveData,
  ApiMcpServersRetrieveResponses,
  ApiMcpServersUpdateData,
  ApiMcpServersUpdateResponses,
  ApiMeRetrieveData,
  ApiMeRetrieveResponses,
  ApiMicrosoftGraphAdminConsentCallbackRetrieveData,
  ApiMicrosoftGraphAdminConsentRevokeCreateData,
  ApiMicrosoftGraphAdminConsentRevokeCreateResponses,
  ApiMicrosoftGraphAdminConsentStartCreateData,
  ApiMicrosoftGraphAdminConsentStartCreateResponses,
  ApiMicrosoftGraphAdminConsentStatusRetrieveData,
  ApiMicrosoftGraphAdminConsentStatusRetrieveResponses,
  ApiMicrosoftGraphBrowseDrivesChildrenRetrieveData,
  ApiMicrosoftGraphBrowseDrivesChildrenRetrieveResponses,
  ApiMicrosoftGraphBrowseDrivesSearchRetrieveData,
  ApiMicrosoftGraphBrowseDrivesSearchRetrieveResponses,
  ApiMicrosoftGraphBrowseSitesDrivesRetrieveData,
  ApiMicrosoftGraphBrowseSitesDrivesRetrieveResponses,
  ApiMicrosoftGraphBrowseSitesRetrieveData,
  ApiMicrosoftGraphBrowseSitesRetrieveResponses,
  ApiMicrosoftGraphConnectCallbackRetrieveData,
  ApiMicrosoftGraphConnectStartCreateData,
  ApiMicrosoftGraphConnectStartCreateResponses,
  ApiMicrosoftGraphDisconnectCreateData,
  ApiMicrosoftGraphDisconnectCreateResponses,
  ApiMicrosoftGraphStatusRetrieveData,
  ApiMicrosoftGraphStatusRetrieveResponses,
  ApiObservabilityFeedbackRetrieveData,
  ApiObservabilityFeedbackRetrieveResponses,
  ApiObservabilityMetricsRetrieveData,
  ApiObservabilityMetricsRetrieveResponses,
  ApiObservabilityModelsRetrieveData,
  ApiObservabilityModelsRetrieveResponses,
  ApiObservabilityRunsFeedbackDestroyData,
  ApiObservabilityRunsFeedbackDestroyResponses,
  ApiObservabilityRunsFeedbackUpdateData,
  ApiObservabilityRunsFeedbackUpdateResponses,
  ApiObservabilitySummaryRetrieveData,
  ApiObservabilitySummaryRetrieveResponses,
  ApiObservabilityThreadsRatingsRetrieveData,
  ApiObservabilityThreadsRatingsRetrieveResponses,
  ApiObservabilityThreadsRetrieveData,
  ApiObservabilityThreadsRetrieveResponses,
  ApiObservabilityTracesFeedbackDestroyData,
  ApiObservabilityTracesFeedbackDestroyResponses,
  ApiObservabilityTracesFeedbackUpdateData,
  ApiObservabilityTracesFeedbackUpdateResponses,
  ApiObservabilityTracesRetrieve2Data,
  ApiObservabilityTracesRetrieve2Responses,
  ApiObservabilityTracesRetrieveData,
  ApiObservabilityTracesRetrieveResponses,
  ApiProvidersModelsRetrieveData,
  ApiProvidersModelsRetrieveResponses,
  ApiProvidersRetrieveData,
  ApiProvidersRetrieveResponses,
  ApiRunsCancelCreateData,
  ApiRunsCancelCreateResponses,
  ApiRunsClearDestroyData,
  ApiRunsClearDestroyResponses,
  ApiRunsDestroyData,
  ApiRunsDestroyResponses,
  ApiRunsListData,
  ApiRunsListResponses,
  ApiRunsRetrieveData,
  ApiRunsRetrieveResponses,
  ApiRunsStepsListData,
  ApiRunsStepsListResponses,
  ApiRunsStreamRetrieveData,
  ApiRunsStreamRetrieveResponses,
  ApiSchedulesCreateData,
  ApiSchedulesCreateResponses,
  ApiSchedulesDestroyData,
  ApiSchedulesDestroyResponses,
  ApiSchedulesListData,
  ApiSchedulesListResponses,
  ApiSchedulesPartialUpdateData,
  ApiSchedulesPartialUpdateResponses,
  ApiSchedulesRetrieveData,
  ApiSchedulesRetrieveResponses,
  ApiSchedulesUpdateData,
  ApiSchedulesUpdateResponses,
  ApiSkillsCreateData,
  ApiSkillsCreateResponses,
  ApiSkillsDestroyData,
  ApiSkillsDestroyResponses,
  ApiSkillsListData,
  ApiSkillsListResponses,
  ApiSkillsPartialUpdateData,
  ApiSkillsPartialUpdateResponses,
  ApiSkillsRetrieveData,
  ApiSkillsRetrieveResponses,
  ApiSkillsUpdateData,
  ApiSkillsUpdateResponses,
  ApiTemplatesListData,
  ApiTemplatesListResponses,
  ApiTemplatesRetrieveData,
  ApiTemplatesRetrieveResponses,
  ApiTemplatesUseCreateData,
  ApiTemplatesUseCreateResponses,
  ApiThreadsCompactCreateData,
  ApiThreadsCompactCreateResponses,
  ApiThreadsDestroyData,
  ApiThreadsDestroyResponses,
  ApiThreadsFilesListData,
  ApiThreadsFilesListResponses,
  ApiThreadsListData,
  ApiThreadsListResponses,
  ApiThreadsMessagesRetrieveData,
  ApiThreadsMessagesRetrieveResponses,
  ApiThreadsRenamePartialUpdateData,
  ApiThreadsRenamePartialUpdateResponses,
  ApiThreadsRetrieveData,
  ApiThreadsRetrieveResponses,
  ApiToolsRetrieveData,
  ApiToolsRetrieveResponses,
  ApiUsageBreakdownRetrieveData,
  ApiUsageBreakdownRetrieveResponses,
  ApiUsagePlatformSummaryRetrieveData,
  ApiUsagePlatformSummaryRetrieveResponses,
  ApiUsageSummaryRetrieveData,
  ApiUsageSummaryRetrieveResponses,
  ApiVoiceConfigRetrieveData,
  ApiVoiceConfigRetrieveResponses,
  ApiVoiceSttCreateData,
  ApiVoiceSttCreateErrors,
  ApiVoiceSttCreateResponses,
  ApiVoiceTtsCreateData,
  ApiVoiceTtsCreateErrors,
  ApiVoiceTtsCreateResponses,
  ApiVoiceVoicesRetrieveData,
  ApiVoiceVoicesRetrieveErrors,
  ApiVoiceVoicesRetrieveResponses,
  ApiWidgetChatCreateData,
  ApiWidgetChatCreateResponses,
  ApiWidgetConfigRetrieveData,
  ApiWidgetConfigRetrieveResponses,
  ApiWidgetMessagesRetrieveData,
  ApiWidgetMessagesRetrieveResponses,
  ApiWidgetOperatorMessagesRetrieveData,
  ApiWidgetOperatorMessagesRetrieveResponses,
  ApiWidgetResumeCreateData,
  ApiWidgetResumeCreateResponses,
  ApiWidgetsCreateData,
  ApiWidgetsCreateResponses,
  ApiWidgetsDestroyData,
  ApiWidgetsDestroyResponses,
  ApiWidgetsListData,
  ApiWidgetsListResponses,
  ApiWidgetsPartialUpdateData,
  ApiWidgetsPartialUpdateResponses,
  ApiWidgetsRetrieveData,
  ApiWidgetsRetrieveResponses,
  ApiWidgetsRotateKeyCreateData,
  ApiWidgetsRotateKeyCreateResponses,
  ApiWidgetsUpdateData,
  ApiWidgetsUpdateResponses,
  ApiWidgetVoiceSttCreateData,
  ApiWidgetVoiceSttCreateErrors,
  ApiWidgetVoiceSttCreateResponses,
  ApiWidgetVoiceTtsCreateData,
  ApiWidgetVoiceTtsCreateErrors,
  ApiWidgetVoiceTtsCreateResponses,
  McpToolsCallCreateData,
  McpToolsCallCreateResponses,
  McpToolsRetrieveData,
  McpToolsRetrieveResponses
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

export const apiAgentsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiAgentsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiAgentsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/',
    ...options
  })

export const apiAgentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersList = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMcpServersListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMcpServersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/mcp-servers/',
    ...options
  })

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMcpServersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsMcpServersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/mcp-servers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMcpServersDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsMcpServersDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{agent_id}/mcp-servers/{id}/', ...options })

/**
 * `/api/agents/<agent_id>/mcp-servers/` — list & attach & detach.
 *
 * Standard DRF verbs:
 * GET    /  → list links of an agent
 * POST   /  → attach server to agent (body: {"server": <uuid>, "is_enabled": bool})
 * DELETE /<id>/ → detach a link
 * PATCH  /<id>/ → toggle `is_enabled`
 */
export const apiAgentsMcpServersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMcpServersPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiAgentsMcpServersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/mcp-servers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemoriesList = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMemoriesListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMemoriesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/',
    ...options
  })

export const apiAgentsMemoriesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMemoriesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsMemoriesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemoriesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMemoriesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsMemoriesDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{agent_id}/memories/{id}/', ...options })

export const apiAgentsMemoriesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMemoriesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMemoriesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/{id}/',
    ...options
  })

export const apiAgentsMemoriesPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiAgentsMemoriesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemoriesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsMemoriesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiAgentsMemoriesUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemoriesDocumentsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMemoriesDocumentsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/documents/',
    ...options
  })

/**
 * Issue a presigned PUT URL + create the `pending` row.
 *
 * No blob touches this process and no parsing is enqueued yet — that
 * happens on `confirm`, once the browser has PUT the bytes to MinIO.
 */
export const apiAgentsMemoriesDocumentsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsMemoriesDocumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/documents/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemoriesDocumentsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsMemoriesDocumentsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{agent_id}/memories/documents/{id}/', ...options })

export const apiAgentsMemoriesDocumentsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMemoriesDocumentsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/documents/{id}/',
    ...options
  })

/**
 * Finalise a presigned upload once the browser's PUT completed.
 *
 * Verifies the object exists, enforces the size limit against its real
 * size (the authoritative gate), then kicks off parsing. Idempotent: a
 * doc that's already past `pending` is returned unchanged.
 */
export const apiAgentsMemoriesDocumentsConfirmCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsConfirmCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsMemoriesDocumentsConfirmCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/documents/{id}/confirm/',
    ...options
  })

/**
 * Semantic search over this agent's chunks.
 *
 * Mirrors the runtime tool `squad_runtime.tools.memory_rag.memory_search`
 * — same SQL, same `embed_query`, same `(account_id, agent_id)` filter.
 * Exposed as REST so the UI can offer the same retrieval users see
 * when the agent calls the tool, with a relevance score per chunk.
 */
export const apiAgentsMemoriesDocumentsSearchCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemoriesDocumentsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsMemoriesDocumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memories/documents/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsMemorySourceRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemorySourceRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsMemorySourceRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memory-source/',
    ...options
  })

export const apiAgentsMemorySourceUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsMemorySourceUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiAgentsMemorySourceUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/memory-source/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `GET .../sharepoint/files/` — the Memory tab's table.
 *
 * Skipped files are listed, never hidden: "why isn't this PNG in memory" has
 * to be answerable from the UI without reading worker logs.
 */
export const apiAgentsSharepointFilesList = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointFilesListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSharepointFilesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/files/',
    ...options
  })

/**
 * `GET .../sharepoint/files/<file_id>/events/` — one file's version journal.
 */
export const apiAgentsSharepointFilesEventsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointFilesEventsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSharepointFilesEventsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/files/{file_id}/events/',
    ...options
  })

export const apiAgentsSharepointScopeRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointScopeRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSharepointScopeRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/scope/',
    ...options
  })

/**
 * Dry-run a scope draft before it is saved.
 *
 * Runs the SAME validator the save path runs, so the preview can never
 * disagree with what saving would do, then checks each entry against Graph
 * under the caller's own connection.
 */
export const apiAgentsSharepointScopeValidateCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointScopeValidateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsSharepointScopeValidateCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/scope/validate/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `POST /api/agents/<id>/sharepoint/sync/` — run one now.
 *
 * Needs write access but NOT the A2.1 admin gate: this re-runs a selection an
 * authorised person already made and adds nothing the scope does not cover.
 */
export const apiAgentsSharepointSyncCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointSyncCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsSharepointSyncCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/sync/',
    ...options
  })

/**
 * `GET .../sharepoint/sync/runs/` — newest first.
 */
export const apiAgentsSharepointSyncRunsList = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointSyncRunsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSharepointSyncRunsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/sync/runs/',
    ...options
  })

/**
 * `GET .../sync/runs/<run_id>/` — one run and everything it did.
 */
export const apiAgentsSharepointSyncRunsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSharepointSyncRunsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSharepointSyncRunsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/sharepoint/sync/runs/{run_id}/',
    ...options
  })

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsList = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsSkillsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsSkillsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/skills/',
    ...options
  })

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsDetachOrToggleDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSkillsDetachOrToggleDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsSkillsDetachOrToggleDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{agent_id}/skills/{id}/detach_or_toggle/', ...options })

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsDetachOrTogglePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSkillsDetachOrTogglePartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiAgentsSkillsDetachOrTogglePartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/skills/{id}/detach_or_toggle/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/agents/<agent_id>/skills/` — list, attach, toggle, detach.
 */
export const apiAgentsSkillsAttachCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsSkillsAttachCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsSkillsAttachCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{agent_id}/skills/attach/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{id}/', ...options })

export const apiAgentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/',
    ...options
  })

export const apiAgentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiAgentsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiAgentsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Run-only assignment: `viewer` collaborators who may RUN but not edit.
 *
 * Distinct from `collaborators` (owner/editor management): the role is
 * forced to `viewer` here, and GET returns only assignees. Used to grant a
 * `restricted` agent to specific users (e.g. a per-seller Follow-Up agent).
 * Gated by the same write authorization as any other agent mutation.
 */
export const apiAgentsAssigneesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsAssigneesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsAssigneesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/assignees/',
    ...options
  })

/**
 * Run-only assignment: `viewer` collaborators who may RUN but not edit.
 *
 * Distinct from `collaborators` (owner/editor management): the role is
 * forced to `viewer` here, and GET returns only assignees. Used to grant a
 * `restricted` agent to specific users (e.g. a per-seller Follow-Up agent).
 * Gated by the same write authorization as any other agent mutation.
 */
export const apiAgentsAssigneesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsAssigneesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsAssigneesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/assignees/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsAssigneesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsAssigneesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsAssigneesDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{id}/assignees/{collab_id}/', ...options })

/**
 * Revoke ONE of the caller's own "Always approve" exceptions for this
 * agent (see AgentAutoApprovedTool). Scoped to the caller's own sso_id —
 * no `_assert_can_write`: this is a personal preference, not an agent
 * edit, so anyone who can reach the agent may revoke their own entry,
 * never anyone else's.
 */
export const apiAgentsAutoApprovedToolsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsAutoApprovedToolsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsAutoApprovedToolsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{id}/auto_approved_tools/{tool_name}/', ...options })

export const apiAgentsCollaboratorsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsCollaboratorsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsCollaboratorsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/collaborators/',
    ...options
  })

export const apiAgentsCollaboratorsCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsCollaboratorsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsCollaboratorsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/collaborators/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiAgentsCollaboratorsDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiAgentsCollaboratorsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiAgentsCollaboratorsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/agents/{id}/collaborators/{collab_id}/', ...options })

export const apiAgentsToolsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsToolsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiAgentsToolsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/tools/',
    ...options
  })

export const apiAgentsToolsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsToolsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiAgentsToolsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/agents/{id}/tools/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `POST /api/agents/scaffold/` — natural-language → Agent draft.
 *
 * Forwards to squad-runtime `/scaffold` and returns the LLM-suggested
 * config as-is. The frontend is responsible for letting the user edit
 * and confirm before we persist anything.
 */
export const apiAgentsScaffoldCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiAgentsScaffoldCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiAgentsScaffoldCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/agents/scaffold/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiApprovalsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiApprovalsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiApprovalsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/approvals/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiApprovalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiApprovalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiApprovalsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/approvals/{id}/',
    ...options
  })

/**
 * Read-only, flat serialization of the policy registry — backs the
 * Approval Policies manifest page.
 */
export const apiApprovalsPoliciesList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiApprovalsPoliciesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiApprovalsPoliciesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/approvals/policies/',
    ...options
  })

/**
 * Dashboard summary for the Approvals inbox — counts, the caller's
 * personal waiting-on-you/expiring-soon numbers, and 7-day trends.
 */
export const apiApprovalsStatsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiApprovalsStatsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiApprovalsStatsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/approvals/stats/',
    ...options
  })

/**
 * `GET/POST /api/card-pause/` — are the agents answering this card?
 *
 * The switch a manager sees in the CRM conversation. It is per card, not per
 * agent: "stop answering this client" means every agent on the card, and a
 * manager should not have to know which one replied last.
 *
 * Reads and writes the same rows the webhook receiver gates on, so the
 * conversation's toggle and a takeover from crm-api cannot disagree.
 */
export const apiCardPauseRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiCardPauseRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiCardPauseRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/card-pause/',
    ...options
  })

/**
 * `GET/POST /api/card-pause/` — are the agents answering this card?
 *
 * The switch a manager sees in the CRM conversation. It is per card, not per
 * agent: "stop answering this client" means every agent on the card, and a
 * manager should not have to know which one replied last.
 *
 * Reads and writes the same rows the webhook receiver gates on, so the
 * conversation's toggle and a takeover from crm-api cannot disagree.
 */
export const apiCardPauseCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiCardPauseCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiCardPauseCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/card-pause/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiChannelsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiChannelsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChannelsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiChannelsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/channels/{id}/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiChannelsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiChannelsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiChannelsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiChannelsCrmSubscriptionDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiChannelsCrmSubscriptionDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/channels/{id}/crm-subscription/', ...options })

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiChannelsCrmSubscriptionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiChannelsCrmSubscriptionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/crm-subscription/',
    ...options
  })

/**
 * GET/PUT/DELETE `/api/channels/<id>/crm-subscription/`.
 *
 * Server-side broker to CRM's `/integrations/squad/config` (the org's single
 * `SquadIntegrationConfig`): resolves the org's CRM app token, forwards the
 * CALLER'S JWT so CRM enforces `configure_integration`, and maps the
 * one-config-per-org constraint into an explicit `current_target` +
 * `force`-guarded overwrite.
 */
export const apiChannelsCrmSubscriptionUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiChannelsCrmSubscriptionUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiChannelsCrmSubscriptionUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/crm-subscription/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiChannelsRotateSecretCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiChannelsRotateSecretCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChannelsRotateSecretCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/channels/{id}/rotate-secret/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Unauthenticated by SaaS-app-token; auth is the HMAC signature.
 */
export const apiChannelsWebhookCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChannelsWebhookCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChannelsWebhookCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/channels/{id}/webhook/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * POST /api/chat/ — creates a run, dispatches it to the worker, tails steps.
 *
 * Execution is owned by the Celery worker (see the RunStep SSE tail note
 * above), NOT this request, so closing the browser tab no longer cancels the
 * run — it keeps going server-side and a returning user sees the rest.
 */
export const apiChatCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChatCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChatCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/chat/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiChatFilesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChatFilesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChatFilesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/chat/files/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiChatFilesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiChatFilesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiChatFilesDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/chat/files/{file_id}/', ...options })

export const apiChatFilesConfirmCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChatFilesConfirmCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChatFilesConfirmCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/chat/files/{file_id}/confirm/',
    ...options
  })

export const apiChatFilesDownloadRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiChatFilesDownloadRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiChatFilesDownloadRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/chat/files/{file_id}/download/',
    ...options
  })

/**
 * POST /api/chat/resume/ — resolves an approval and resumes the run.
 */
export const apiChatResumeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiChatResumeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiChatResumeCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/chat/resume/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiMcpCatalogListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMcpCatalogListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-catalog/',
    ...options
  })

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogConnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpCatalogConnectCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMcpCatalogConnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-catalog/{slug}/connect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/mcp-catalog/` — public list of preset MCP servers + connect/disconnect.
 *
 * Catalog itself is system-wide (no per-workspace rows); the `is_connected`
 * flag on each entry tells the FE whether the current workspace has
 * already provisioned a `McpServer` from it.
 */
export const apiMcpCatalogDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpCatalogDisconnectCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMcpCatalogDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-catalog/{slug}/disconnect/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Every known MCP tool, tagged with its `application` — global,
 * not scoped to the current workspace, so the FE can build a static
 * `(application, tool_name) -> translation` map ahead of time (same
 * idea as `Agent.application`, but for tools).
 *
 * Tool names are never persisted — they're only discoverable live via
 * `squad-runtime` connecting to each MCP server. Redis-cached for 10
 * minutes (`?refresh=1` bypasses); on an unreachable/misbehaving
 * runtime this falls back to the last-good cache, then finally an
 * empty list — this endpoint must never 5xx just because a docs
 * consumer asked at the wrong moment.
 */
export const apiMcpCatalogToolsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiMcpCatalogToolsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMcpCatalogToolsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-catalog/tools/',
    ...options
  })

export const apiMcpServersList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiMcpServersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMcpServersListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/',
    ...options
  })

export const apiMcpServersCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiMcpServersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMcpServersCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiMcpServersDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiMcpServersDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiMcpServersDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/mcp-servers/{id}/', ...options })

export const apiMcpServersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiMcpServersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiMcpServersRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/{id}/',
    ...options
  })

export const apiMcpServersPartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpServersPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiMcpServersPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiMcpServersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiMcpServersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiMcpServersUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Whether this server wants OAuth, and whether we hold a token.
 *
 * Probes live the first time (and on `?refresh=1`); afterwards the answer
 * comes off the row. An unreachable endpoint is reported as `unknown`
 * plus `last_error` — a transient outage must not read as "no auth
 * needed" and silently strip a working connection's badge.
 */
export const apiMcpServersOauthRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpServersOauthRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiMcpServersOauthRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/{id}/oauth/',
    ...options
  })

/**
 * Forget the tokens and the client registration for this server.
 */
export const apiMcpServersOauthDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpServersOauthDisconnectCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMcpServersOauthDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/mcp-servers/{id}/oauth/disconnect/', ...options })

/**
 * Discover + register (once) and hand the FE a consent URL.
 */
export const apiMcpServersOauthStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMcpServersOauthStartCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMcpServersOauthStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/mcp-servers/{id}/oauth/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `/api/mcp/oauth/callback/` — public, reached by the user's browser
 * straight from the MCP server's authorization server.
 *
 * No SAAS-APP-TOKEN or JWT is present on this hop, so the `state` row
 * created by `oauth_start` is the only thing that says which server (and
 * workspace) the code belongs to — same contract as the Microsoft Graph
 * callback. Errors always redirect back to the FE with a readable reason
 * rather than rendering a bare DRF error page at an API URL.
 */
export const apiMcpOauthCallbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMcpOauthCallbackRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/api/mcp/oauth/callback/',
    ...options
  })

export const apiMeRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiMeRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMeRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/me/',
    ...options
  })

/**
 * Public — reached by the admin's browser directly from Microsoft. No
 * `code` here (this is a boolean admin-consent confirmation, not an
 * authorization-code exchange).
 */
export const apiMicrosoftGraphAdminConsentCallbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    ApiMicrosoftGraphAdminConsentCallbackRetrieveData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/api/microsoft-graph/admin-consent/callback/',
    ...options
  })

/**
 * Admin-only: deactivate SharePoint for this workspace. Deletes the
 * local consent record — this doesn't call Microsoft to rescind the
 * tenant-side admin consent (would need elevated Graph permissions this
 * app doesn't request), but via `_org_activated` it immediately cuts off
 * every delegated per-user connection. An admin can reactivate by granting
 * again.
 */
export const apiMicrosoftGraphAdminConsentRevokeCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMicrosoftGraphAdminConsentRevokeCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ApiMicrosoftGraphAdminConsentRevokeCreateResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/microsoft-graph/admin-consent/revoke/', ...options })

export const apiMicrosoftGraphAdminConsentStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMicrosoftGraphAdminConsentStartCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMicrosoftGraphAdminConsentStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/admin-consent/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiMicrosoftGraphAdminConsentStatusRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<
    ApiMicrosoftGraphAdminConsentStatusRetrieveData,
    ThrowOnError
  >
) =>
  (options?.client ?? client).get<
    ApiMicrosoftGraphAdminConsentStatusRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/admin-consent/status/',
    ...options
  })

/**
 * `GET /api/microsoft-graph/browse/drives/<drive_id>/children/` — root when
 * no `item_id` is given.
 */
export const apiMicrosoftGraphBrowseDrivesChildrenRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApiMicrosoftGraphBrowseDrivesChildrenRetrieveData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    ApiMicrosoftGraphBrowseDrivesChildrenRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/browse/drives/{drive_id}/children/',
    ...options
  })

/**
 * `GET /api/microsoft-graph/browse/drives/<drive_id>/search/?q=`.
 */
export const apiMicrosoftGraphBrowseDrivesSearchRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<
    ApiMicrosoftGraphBrowseDrivesSearchRetrieveData,
    ThrowOnError
  >
) =>
  (options.client ?? client).get<
    ApiMicrosoftGraphBrowseDrivesSearchRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/browse/drives/{drive_id}/search/',
    ...options
  })

/**
 * `GET /api/microsoft-graph/browse/sites/` — sites the caller can see.
 *
 * Only `/sites` is listed, which is what keeps personal OneDrive out of the
 * picker by construction even though the delegated grant would reach it.
 */
export const apiMicrosoftGraphBrowseSitesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMicrosoftGraphBrowseSitesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMicrosoftGraphBrowseSitesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/browse/sites/',
    ...options
  })

/**
 * `GET /api/microsoft-graph/browse/sites/<site_id>/drives/`.
 */
export const apiMicrosoftGraphBrowseSitesDrivesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMicrosoftGraphBrowseSitesDrivesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiMicrosoftGraphBrowseSitesDrivesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/browse/sites/{site_id}/drives/',
    ...options
  })

/**
 * Public — reached by the user's browser directly from Microsoft.
 */
export const apiMicrosoftGraphConnectCallbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMicrosoftGraphConnectCallbackRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<unknown, unknown, ThrowOnError>({
    url: '/api/microsoft-graph/connect/callback/',
    ...options
  })

export const apiMicrosoftGraphConnectStartCreate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiMicrosoftGraphConnectStartCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiMicrosoftGraphConnectStartCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/connect/start/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiMicrosoftGraphDisconnectCreate = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMicrosoftGraphDisconnectCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ApiMicrosoftGraphDisconnectCreateResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/microsoft-graph/disconnect/', ...options })

export const apiMicrosoftGraphStatusRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiMicrosoftGraphStatusRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiMicrosoftGraphStatusRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/microsoft-graph/status/',
    ...options
  })

/**
 * This project's 👍/👎 ratings: a tally plus the rated traces. We pull only
 * the traces that carry a "User feedback" score (Opik feedback filter), so this
 * is cheap regardless of total volume — and reliable, unlike `projects/stats`,
 * which aggregates feedback lazily.
 */
export const apiObservabilityFeedbackRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilityFeedbackRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilityFeedbackRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/feedback/', ...options })

/**
 * Time-series for a single `metric_type` (chart). FE calls once per chart.
 */
export const apiObservabilityMetricsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilityMetricsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilityMetricsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/metrics/', ...options })

/**
 * Per-model breakdown for this project — calls / tokens / est. cost,
 * aggregated from LLM spans (model is a span attribute, not on traces). Also
 * powers the Traces tab's model dropdown. Bounded to the most-recent N spans.
 */
export const apiObservabilityModelsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilityModelsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilityModelsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/models/', ...options })

/**
 * Rate a chat turn 👍/👎 by its Squad `run_id` (used by the chat UI). The
 * run's trace is resolved via `metadata.run_id` within the caller's locked
 * project, so a run from another tenant — or one with no trace — 404s.
 */
export const apiObservabilityRunsFeedbackDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityRunsFeedbackDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiObservabilityRunsFeedbackDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/runs/{run_id}/feedback/', ...options })

/**
 * Body: {"up": true|false}.
 */
export const apiObservabilityRunsFeedbackUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityRunsFeedbackUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiObservabilityRunsFeedbackUpdateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/observability/runs/{run_id}/feedback/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * KPI header for the dashboard — project-level aggregates (cost, duration
 * percentiles, token totals, feedback) from Opik's `projects/stats`.
 */
export const apiObservabilitySummaryRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilitySummaryRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilitySummaryRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/summary/', ...options })

/**
 * Paginated conversation threads — project locked.
 */
export const apiObservabilityThreadsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilityThreadsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilityThreadsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/threads/', ...options })

/**
 * Per-run 👍/👎 ratings for one chat thread, so the chat can render each
 * turn's current rating in one call. Keyed by the `run_id` stamped into trace
 * metadata; turns traced before run_id tagging shipped simply don't appear.
 */
export const apiObservabilityThreadsRatingsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityThreadsRatingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiObservabilityThreadsRatingsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/threads/{thread_id}/ratings/', ...options })

/**
 * Paginated trace list — project locked via `project_name`. An optional
 * `thread_id` narrows to one conversation thread (used by the Threads drawer);
 * it's applied via Opik's trace filter, still within the locked project.
 */
export const apiObservabilityTracesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiObservabilityTracesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiObservabilityTracesRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/traces/', ...options })

/**
 * One trace + its span tree. Verifies the trace belongs to THIS account's
 * project before returning anything (tenant isolation on an unauthed Opik).
 */
export const apiObservabilityTracesRetrieve2 = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityTracesRetrieve2Data, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiObservabilityTracesRetrieve2Responses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/traces/{trace_id}/', ...options })

/**
 * Clear the rating.
 */
export const apiObservabilityTracesFeedbackDestroy = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityTracesFeedbackDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiObservabilityTracesFeedbackDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/observability/traces/{trace_id}/feedback/', ...options })

/**
 * Set the rating. Body: {"up": true|false}.
 */
export const apiObservabilityTracesFeedbackUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiObservabilityTracesFeedbackUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiObservabilityTracesFeedbackUpdateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/observability/traces/{trace_id}/feedback/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiProvidersRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiProvidersRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiProvidersRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/providers/', ...options })

export const apiProvidersModelsRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiProvidersModelsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiProvidersModelsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/providers/{key}/models/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiRunsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiRunsListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/runs/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiRunsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiRunsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/runs/{id}/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiRunsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiRunsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiRunsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/runs/{id}/',
    ...options
  })

/**
 * Mark an in-flight run as ERROR so polling clients stop spinning.
 *
 * We can't actually interrupt the upstream runtime worker from here
 * (it owns its own process and SSE socket), but flipping the status
 * to ERROR is enough for the FE: the `/messages/` endpoint stops
 * reporting it as `active_run`, polling stops, and any later events
 * from a zombie worker will be discarded — token rows still land in
 * the run's `steps` for audit but the UI no longer treats the run
 * as alive.
 *
 * DONE / ERROR runs are returned unchanged so a duplicate Stop click
 * (or a race with the janitor) is idempotent. PAUSED runs are
 * cancellable: a user explicitly abandoning an approval should mean
 * the run is over, not stuck waiting forever.
 */
export const apiRunsCancelCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiRunsCancelCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiRunsCancelCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/runs/{id}/cancel/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `GET /api/runs/<run_id>/steps/` — full timeline for the trace viewer.
 */
export const apiRunsStepsList = <ThrowOnError extends boolean = false>(
  options: Options<ApiRunsStepsListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiRunsStepsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/runs/{run_id}/steps/',
    ...options
  })

/**
 * `GET /api/runs/<run_id>/stream/` — reattach to a run's live SSE tail
 * after a client disconnected (tab close/reload, transport drop), without
 * starting a new run.
 *
 * Execution is worker-owned (see `ChatStreamView`), so the run keeps going
 * regardless of who's tailing it — this just opens another `_tail_run_steps`
 * generator against the same `RunStep` rows. `?since=<step_index>` (default
 * 0) skips steps the caller already has; pass the count from
 * `/api/runs/<run_id>/steps/` to resume without duplicates. If the run has
 * already reached a terminal status, the tail emits the closing event
 * immediately instead of waiting out the idle timeout.
 */
export const apiRunsStreamRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiRunsStreamRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiRunsStreamRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/runs/{run_id}/stream/', ...options })

/**
 * Bulk-delete runs that match the same filters as `list`.
 *
 * Used by the Inbox UI's "Clear" button. The destructive scope is
 * the same query string the FE just listed against — so `?trigger=
 * schedule&status=done` clears only successful scheduled runs.
 */
export const apiRunsClearDestroy = <ThrowOnError extends boolean = false>(
  options?: Options<ApiRunsClearDestroyData, ThrowOnError>
) =>
  (options?.client ?? client).delete<
    ApiRunsClearDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/runs/clear/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiSchedulesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiSchedulesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/schedules/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSchedulesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiSchedulesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/schedules/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiSchedulesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiSchedulesDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/schedules/{id}/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiSchedulesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiSchedulesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/schedules/{id}/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSchedulesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiSchedulesPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/schedules/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiSchedulesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSchedulesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiSchedulesUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/schedules/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiSkillsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiSkillsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiSkillsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/skills/',
    ...options
  })

export const apiSkillsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSkillsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiSkillsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/skills/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiSkillsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiSkillsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiSkillsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/skills/{id}/', ...options })

export const apiSkillsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiSkillsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiSkillsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/skills/{id}/',
    ...options
  })

export const apiSkillsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSkillsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiSkillsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/skills/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiSkillsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiSkillsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiSkillsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/skills/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

export const apiTemplatesList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiTemplatesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiTemplatesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/templates/',
    ...options
  })

export const apiTemplatesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiTemplatesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiTemplatesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/templates/{id}/',
    ...options
  })

export const apiTemplatesUseCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiTemplatesUseCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiTemplatesUseCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/templates/{id}/use/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiThreadsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiThreadsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiThreadsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiThreadsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/threads/{id}/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiThreadsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiThreadsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiThreadsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/{id}/',
    ...options
  })

/**
 * Manually compress the thread's model context (summarise + drop old
 * messages in the checkpointer). UI chat history is untouched. Rejected
 * while a run is in flight so we never mutate live state.
 */
export const apiThreadsCompactCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiThreadsCompactCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiThreadsCompactCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/{id}/compact/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Every ready file in this thread — user uploads and agent files — newest first.
 */
export const apiThreadsFilesList = <ThrowOnError extends boolean = false>(
  options: Options<ApiThreadsFilesListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiThreadsFilesListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/{id}/files/',
    ...options
  })

/**
 * Replay a thread's user/assistant turns from persisted runs+steps.
 *
 * We don't pull from the LangGraph checkpointer (different Postgres
 * schema, async-only API). Instead we walk this thread's runs in
 * chronological order — `Run.input.message` is the user turn, and the
 * concatenated text steps for that run are the assistant turn.
 *
 * Also surfaces `active_run` so the FE can keep showing a typing
 * indicator (and poll for completion) when the user navigates back
 * into a thread whose stream is still being generated server-side.
 */
export const apiThreadsMessagesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiThreadsMessagesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiThreadsMessagesRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/{id}/messages/',
    ...options
  })

/**
 * Rename a thread — narrowly scoped so callers can't change
 * `agent_id` or any of the annotated/derived fields.
 */
export const apiThreadsRenamePartialUpdate = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiThreadsRenamePartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiThreadsRenamePartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/threads/{id}/rename/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `GET /api/tools/` — public catalog used by the agent builder.
 */
export const apiToolsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiToolsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiToolsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/tools/', ...options })

export const apiUsageBreakdownRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiUsageBreakdownRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiUsageBreakdownRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/usage/breakdown/', ...options })

/**
 * Cross-tenant usage roll-up: one row per account (org).
 */
export const apiUsagePlatformSummaryRetrieve = <
  ThrowOnError extends boolean = false
>(
  options?: Options<ApiUsagePlatformSummaryRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiUsagePlatformSummaryRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/usage/platform/summary/', ...options })

export const apiUsageSummaryRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiUsageSummaryRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiUsageSummaryRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/usage/summary/', ...options })

/**
 * GET /api/voice/config/ — one call at chat mount.
 *
 * Answers "may this caller use voice, and how much is left", so no surface
 * ever has to discover a missing key or an exhausted allowance by getting an
 * error from a button the user already pressed.
 */
export const apiVoiceConfigRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiVoiceConfigRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiVoiceConfigRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/voice/config/', ...options })

/**
 * POST /api/voice/stt/ — transcribe one utterance.
 *
 * The transcript is returned to the caller, NOT sent to the agent. It lands
 * in the composer so the user can correct it before pressing send, which
 * keeps `POST /api/chat/` the single chat entry point and means a
 * mis-transcription never silently becomes an agent action.
 */
export const apiVoiceSttCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiVoiceSttCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiVoiceSttCreateResponses,
    ApiVoiceSttCreateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/api/voice/stt/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers
    }
  })

/**
 * POST /api/voice/tts/ — synthesise one chunk.
 *
 * One short request per sentence-sized chunk, never one stream per answer.
 * squad-api runs gunicorn `gthread` (4 workers x 8 threads = 32 request slots
 * in production) and a streaming response holds a thread for its whole
 * lifetime; every active chat already holds one. A second long-lived stream
 * per conversation would halve effective capacity per pod.
 */
export const apiVoiceTtsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiVoiceTtsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiVoiceTtsCreateResponses,
    ApiVoiceTtsCreateErrors,
    ThrowOnError
  >({
    url: '/api/voice/tts/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * GET /api/voice/voices/ — the vendor catalog for the agent-builder picker.
 *
 * Cached under one global key: the catalog belongs to our single platform
 * account, so it is the same list for every tenant.
 */
export const apiVoiceVoicesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiVoiceVoicesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiVoiceVoicesRetrieveResponses,
    ApiVoiceVoicesRetrieveErrors,
    ThrowOnError
  >({ url: '/api/voice/voices/', ...options })

/**
 * POST /api/widget/<public_key>/chat/ — anonymous SSE chat.
 *
 * Creates a WIDGET run, dispatches it headless (worker owns execution, like a
 * webhook), then tails the RunSteps as SSE (like `ChatStreamView`) so the
 * visitor sees the answer stream. If the agent pauses for a tool approval the
 * tail emits `paused` and the widget shows a graceful fallback — approval
 * cards are never exposed to anonymous visitors.
 */
export const apiWidgetChatCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetChatCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetChatCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/widget/{public_key}/chat/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * GET /api/widget/<public_key>/config/ — display config for the widget UI.
 */
export const apiWidgetConfigRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetConfigRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiWidgetConfigRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/widget/{public_key}/config/', ...options })

/**
 * GET /api/widget/<public_key>/messages/?visitor_id= — history replay.
 */
export const apiWidgetMessagesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetMessagesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiWidgetMessagesRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/widget/{public_key}/messages/', ...options })

/**
 * GET /api/widget/<public_key>/operator-messages/?visitor_id=&since= — a manager's replies.
 *
 * Separate from the history replay, and for one reason: an open page polls this every few
 * seconds, and the replay rebuilds the whole conversation out of runs and steps. This is one
 * indexed query over one small table.
 */
export const apiWidgetOperatorMessagesRetrieve = <
  ThrowOnError extends boolean = false
>(
  options: Options<ApiWidgetOperatorMessagesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiWidgetOperatorMessagesRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/widget/{public_key}/operator-messages/', ...options })

/**
 * POST /api/widget/<public_key>/resume/ — anonymous visitor answers a
 * pending `ask_user` question.
 *
 * Deliberately narrow: this is the ONLY approval type ever exposed to an
 * anonymous widget visitor (`WidgetChatView`'s docstring — write/destructive
 * tool approvals stay hidden). Two checks enforce that on every request:
 * the approval's thread must be THIS visitor's own thread (can't resume
 * someone else's paused run), and its payload must satisfy
 * `_is_ask_user_payload` — `kind="ask_user"` or the legacy
 * `type="ask_user_question"` (can't drive a write-tool gate through this
 * path).
 */
export const apiWidgetResumeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetResumeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetResumeCreateResponses,
    unknown,
    ThrowOnError
  >({
    url: '/api/widget/{public_key}/resume/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * POST /api/widget/<public_key>/voice/stt/ — anonymous transcription.
 *
 * Gated by its OWN switch on top of `voice_enabled`. An owner may reasonably
 * want the agent to speak to visitors without accepting audio uploads from
 * them, and the disclosure obligation for recording a stranger's voice is not
 * the same as for playing them a sentence.
 */
export const apiWidgetVoiceSttCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetVoiceSttCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetVoiceSttCreateResponses,
    ApiWidgetVoiceSttCreateErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/api/widget/{public_key}/voice/stt/',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers
    }
  })

/**
 * POST /api/widget/<public_key>/voice/tts/ — anonymous synthesis.
 */
export const apiWidgetVoiceTtsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetVoiceTtsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetVoiceTtsCreateResponses,
    ApiWidgetVoiceTtsCreateErrors,
    ThrowOnError
  >({
    url: '/api/widget/{public_key}/voice/tts/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsList = <ThrowOnError extends boolean = false>(
  options?: Options<ApiWidgetsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ApiWidgetsListResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ApiWidgetsDestroyResponses,
    unknown,
    ThrowOnError
  >({ url: '/api/widgets/{id}/', ...options })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ApiWidgetsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/{id}/',
    ...options
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    ApiWidgetsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    ApiWidgetsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * Restrict a queryset to agents the caller may read.
 *
 * For models with an `agent` FK (directly or via a relation). Compose it
 * BEFORE `AccountFilterMixin` in the base list so account scoping runs first
 * via `super().filter_queryset(...)`. Override `agent_fk_path` for indirect
 * relations (e.g. Run -> thread -> agent).
 */
export const apiWidgetsRotateKeyCreate = <ThrowOnError extends boolean = false>(
  options: Options<ApiWidgetsRotateKeyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ApiWidgetsRotateKeyCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseType: 'json',
    url: '/api/widgets/{id}/rotate-key/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  })

/**
 * `GET /mcp/tools/` — the tool descriptors.
 *
 * Authorization filtering happens *inside* each tool when invoked, so the
 * descriptor list is the same for any authenticated user.
 */
export const mcpToolsRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<McpToolsRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    McpToolsRetrieveResponses,
    unknown,
    ThrowOnError
  >({ url: '/mcp/tools/', ...options })

/**
 * `POST /mcp/tools/<name>/call/` — invoke a tool as the authenticated user.
 *
 * Body: `{"args": {...}}` (or empty). Response mirrors MCP:
 * - success: `{"result": <dict>}`
 * - error:   `{"error": {"code": <str>, "message": <str>}}`
 */
export const mcpToolsCallCreate = <ThrowOnError extends boolean = false>(
  options: Options<McpToolsCallCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    McpToolsCallCreateResponses,
    unknown,
    ThrowOnError
  >({ url: '/mcp/tools/{tool_name}/call/', ...options })
